import { i18n } from "../../../boot/i18n.js";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "customer-service",
      path: "service",
      props: true,
      meta: {
        icon: "service",
        title: () =>
          i18n.global.tc(
            store.getters.isCustomer() ? "Service" : "Customer Service"
          ),
        widget: "CustomerServiceIssues",
      },
      component: () => import("pages/customer/Home"),
    },
    {
      name: "customer-projects",
      path: "projects",
      props: true,
      meta: {
        icon: "project",
        title: () => i18n.global.tc("Project", 100),
        widget: "CustomerProjects",
      },
      component: () => import("pages/customer/Home"),
    },
    // The project page this replaced: its links open the project's dialog
    // over the Projects widget.
    {
      path: "service/:projectID",
      redirect: ({ params }) => ({
        name: "customer-projects",
        params: { customerID: params.customerID },
        hash: `#/c/${params.customerID}/projects/${params.projectID}`,
      }),
    },
  ],

  dialogs: [
    {
      name: "customer-project",
      path: "/c/:customerID/projects/:projectID",
      props: true,
      meta: {
        icon: "project",
        title: i18n.global.tc("Project"),
      },
      component: () => import("../../../dialogs/customer/ProjectView"),
    },
    {
      name: "customer-report-issue",
      path: "/c/:customerID/service/:projectID/report-issue",
      props: true,
      meta: {
        icon: "add_circle",
        title: i18n.global.t("Report an Issue"),
      },
      component: () => import("../../../dialogs/customer/ReportIssue"),
    },
    {
      name: "customer-service-issue-view",
      path: "/c/:customerID/service/issues/:issueID",
      props: true,
      meta: {
        icon: "issue",
        title: i18n.global.t("Service Issue"),
      },
      component: () => import("../../../dialogs/customer/ServiceIssueView"),
    },
  ],
};
